import { primaryTextColor, secondaryTextColor } from 'themes/theme'
const accountStyle = {
  title: {
    paddingTop: '30px',
    color: primaryTextColor,
    fontWeight: 'bold',
    fontSize: '1.25rem',
  },
  main: {
    paddingLeft: '30px',
  },
  percentage: {
    color: secondaryTextColor,
  },
  chart: {
    height: '80px',
  },
  tabs: {
    '& .MuiTab-root': {
      textTransform: 'none',
      fontSize: '1.5rem',
      fontFamily: 'poppins',
      color: 'var(--primary)',
      fontWeight: 'lighter',
    },
    '& .MuiTab-root.Mui-selected': {
      fontWeight: 'bold',
      color: 'var(--primary)',
    },
  },
}
export default accountStyle
